import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { TwitterButton, EmailButton } from 'react-social'
import config from 'config'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './AmazonStaffTakeActionShare.css'


@CSSModules(Styles,{allowMultiple:true})
export default class AmazonStaffTakeActionShare extends Component {
  render() {
    const planId = 'amazon-com'
    const planData = config.plansSource[planId]
    const description = `See how ${planData.plan_short_name} is rated on environmental and social sustainability issues.`
    const url = config.domain + config.routes.plans + '/' + planId
    //
    return (
      <div styleName='take-action-share'>
        <div styleName='take-action-label'>
          <h2>
            Email or share Amazon's results
          </h2>
          <p>
            Share the scorecard for Amazon's 401(k) with your employer, coworkers, or social network.
          </p>
          <p>
            <Link
              to={config.routes.plans + '/amazon-com'}
              title='Amazon retirement plan sustainability scorecard'
            >
              <span styleName='show-results-button'>
                See Amazon's results<LinkIcon />
              </span>
            </Link>
          </p>
        </div>
        <div styleName='take-action-icons'>
          <div>
            <EmailButton
              title='Share via email'
              message={description}
              url={url}
              element='a'
            >
              <p>
                Email
              </p>
              <div>
                <LinkIcon nospace faclass='fa-envelope'/>
              </div>
            </EmailButton>
          </div>
          <div>
            <Link
              to={'https://www.facebook.com/sharer/sharer.php?u='+url}
              title='Share via Facebook'
            >
              <p>
                Facebook
              </p>
              <div>
                <LinkIcon nospace faclass='fa-facebook-square'/>
              </div>
            </Link>
          </div>
          <div>
            <TwitterButton
              title='Share via Twitter'
              message={description}
              url={url}
              element='a'
            >
              <p>
                Twitter
              </p>
              <div>
                <LinkIcon nospace faclass='fa-twitter-square'/>
              </div>
            </TwitterButton>
          </div>
        </div>
      </div>
    )
  }
}